import {create} from 'zustand';
import type {VelaTaxFacts} from '../engine/types';

type VelaTaxesStore = {
  taxes: VelaTaxFacts;
  setTaxes: (taxes: VelaTaxFacts) => void;
};

export const EMPTY_VELA_TAXES: VelaTaxFacts = {
  rate: '',
  perGuest: '',
  isPerDay: false,
  exemptCount: 0,
  unregisteredCount: 0,
  canDeclareExemptions: false,
};

export const useVelaTaxesStore = create<VelaTaxesStore>(set => ({
  taxes: EMPTY_VELA_TAXES,
  setTaxes: taxes => set({taxes}),
}));
